import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { cleanupIndecxNpsWidget } from './cleanupIndecxWidget';

/** Garante que o NPS IndeCX não permaneça visível fora de /portal. */
const IndecxNpsRouteGuard = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname !== '/portal') {
      cleanupIndecxNpsWidget();
    }
  }, [pathname]);

  return null;
};

export default IndecxNpsRouteGuard;
